<template>
  <div id="con">
    <div class="bg"></div>
    <div class="home">
      <UserInfo class="UserInfo1" v-bind="coo"></UserInfo>
      <UserInfo class="UserInfo1" v-bind="conn"></UserInfo>
      <UserInfo class="UserInfo1" v-bind="job"></UserInfo>
    </div>
  </div>
</template>

<style scoped>
#con {
  width: 100%;
  position: relative;
}
.home {
  width: calc(100% - 32px);
  padding-top: 32px;
  max-width: 1200px;
  margin: 0 auto;
}
.bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background-color: #303133;
}
.UserInfo1 {
  z-index: 100;
  margin-bottom: 32px;
}
</style>

<script>
import { coo, conn, job } from "@/assets/productions.js";
import UserInfo from "@/components/UserInfo.vue";

export default {
  components: {
    UserInfo
  },
  data() {
    return {
      coo: coo,
      conn: conn,
      job: job
    };
  }
};
</script>
